import { useVisibleT } from "@/lib/cms/cms-new-i18n";
import { cn } from "@/lib/utils";
import { Download } from "lucide-react";
import { forwardRef } from "react";
import { Button, ButtonProps } from "../ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";

/**
 * Export trigger of the sheet header in Essentiel mode: icon with the
 * "Exporter" label underneath (both inside the click area) and a help tooltip.
 * Forwards its ref and props so it can sit under a Radix `asChild` trigger.
 */
const ExportButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, ...props }, ref) => {
    const vt = useVisibleT();

    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            ref={ref}
            type="button"
            variant="outline"
            className={cn(
              "h-auto flex-col gap-0 border-0 px-3 py-px text-xs font-medium text-gray-950 shadow-none",
              className,
            )}
            {...props}
          >
            <Download className="h-5 w-5" aria-hidden />
            {vt("bo.button.exportSheet", "Exporter")}
          </Button>
        </TooltipTrigger>
        <TooltipContent
          side="bottom"
          className="bg-black rounded-xl px-3"
          arrowClassName="bg-black fill-black"
        >
          <span className="text-white text-sm font-medium">
            {vt(
              "bo.tooltip.exportSheet",
              "Exporter la fiche au format PDF ou Word",
            )}
          </span>
        </TooltipContent>
      </Tooltip>
    );
  },
);

export default ExportButton;
